
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="DownloadSvg" xmlns="http://www.w3.org/2000/svg" data-name="01_Atoms/Icons/download" viewBox="0 0 24 24"><g data-name="Group 6621"><path fill="none" d="M0 0h24v24H0z" data-name="Rectangle 1453"/></g><g data-name="Group 6622"><path d="M18 15v3H6v-3H4v3a2.006 2.006 0 002 2h12a2.006 2.006 0 002-2v-3zm-1-4l-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5z" data-name="Path 8256"/></g></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'DownloadSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
